import { render, staticRenderFns } from "./AuthorNamesRouterLink.vue?vue&type=template&id=f7060ca2&scoped=true&"
import script from "./AuthorNamesRouterLink.vue?vue&type=script&lang=js&"
export * from "./AuthorNamesRouterLink.vue?vue&type=script&lang=js&"
import style0 from "./AuthorNamesRouterLink.vue?vue&type=style&index=0&id=f7060ca2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7060ca2",
  null
  
)

export default component.exports